module.exports = __webpack_public_path__ + "img/1557614098329444354.f358a28a.png";